import './public-path';
import Spread from './Spread';
import Message from './Message';
import Swipe from './Swipe';
import UserEvents from "./UserEvents";
import {pushAnalyticsEvent, pageView} from "./Analytics";
import { checkBrowser } from "./Utils"
import CONSTANTS, {LAYOUT_DESKTOP, PAGETYPES} from "./Constants";

import '../css/main.scss'
import 'owl.carousel/dist/assets/owl.carousel.min.css'

class Controller {

    constructor(){
        this.BUILDINFO = BUILD;

        //for preview this is false.
        this.spreads = new Map();

        if(window.frontend === undefined && typeof Native !== 'function'){

            if($('[data-spread_id]').length === 1){
                if( window.MaglrEditorPreview ) {
                    this.bindMessageListener();
                }else{
                    this.setSingleSpread();
                }
            }


            this.bindKeyboardNavigation();
        }else if(window.frontend === true && window.location.hostname.indexOf("embed.") > -1){
            window.maglrEmbedId = window.location.pathname.substr(1);
            this.embedHandshake = {
                counter: 0,
                timeout: null,
                connected: false
            }
            //embedded spreads in iframe
            this.setConnectorSingleSpread("embed");
            this.bindMessageListener();
        }

        if (window.previewMode) { // set by the frontend
            this.bindPreviewMessageListener()
        }

        window.addEventListener('beforeunload', () => {
            console.log("BEFORE UNLOAD");

            this.spreads.forEach((spread) => {
                if(spread.status > CONSTANTS.STATUS.STOPPED){
                    spread.reportScrollDepth()
                }
            })
        });
    }

    destroySpread(spread_id, expectedInstance){
        const spread = this.spreads.get(spread_id);
        if (spread && (!expectedInstance || spread === expectedInstance)) {
            try{
                spread.destroy();
                return true;
            }catch(e){
                console.error(`Error during spread.destroy() for [${spread_id}]`, e)
            }finally{
                if (this.spreads.get(spread_id) === spread) this.spreads.delete(spread_id);
                if (this.currentSpread === spread) this.currentSpread = null;
                if (this.currentSpreadId === spread_id) this.currentSpreadId = null;
            }
        }
        return false;
    }

    createSpread(spread_id, settings, options = {}){
        // Destroy old listeners before a replacement installs listeners with the same ID.
        if (this.spreads.has(spread_id)) this.destroySpread(spread_id);
        if(this._singleSpreadMode && this._singleSpreadMode !== 'inject'){
            //replaceables
            if(!options.replaceables && window.replaceables && window.replaceables[spread_id]){
                options.replaceables = window.replaceables[spread_id];
            }
            //cookiewall
            if(options.cookieConsent){
                this.initCookieBar();
            }
        }

        let spread = new Spread(spread_id, settings, options);
        spread.setGlobalData(this.globalData).setInterfaceSettings(this.interfaceSettings);

        this.spreads.set(spread_id, spread);
        try {
            spread.init();
        } catch (error) {
            this.destroySpread(spread_id, spread);
            throw error;
        }

        return this; //chainable
    }

    startSpread(spread_id, options = {}){
        if(this.spreads.has(spread_id)){
            //this.currentSpreadId = spread_id;

            const spread = this.spreads.get(spread_id);
            if (spread.isEditorPreview()) {
                // Feeds plugins/preview.js in the classic preview document.
                document.dispatchEvent(new Event('SPREAD_READY'));
            }

            try{
                this.currentSpread = spread;
                this.currentSpread.start(options).getSpreadElement().addClass("current-spread");

                if( this._singleSpreadMode && this._singleSpreadMode !== 'inject' ){ //Only hit a pageview when in embed or singlepage mode.
                    pageView();
                }

            }catch (e) {
                switch(e.type){
                    case CONSTANTS.ERRORS.NO_SCENES:
                    case CONSTANTS.ERRORS.NOT_VISIBLE:
                        console.warn(e.type, e);
                        break;
                    default:
                        console.error(e);
                        break;
                }
            }

            if( window.maglrEmbedId ){
                this.initiateEmbedHandshake()
            }

            if (options.multiActions) {
                if (options.multiActions[0].type === 'highlight') {
                    this.currentSpread.goToAndHighlightElement(options.multiActions[0].data)
                } else {
                    this.multiActionLink(options.multiActions)
                }
            }
        }

        return this; //chainable
    }

    pauseSpread(spread_id){
        if(this.spreads.has(spread_id)){
            this.spreads.get(spread_id).pause();
        }

        return this; //chainable
    }

    stopSpread(spread_id){
        if(this.spreads.has(spread_id)){
            this.spreads.get(spread_id).stop().getSpreadElement().removeClass("current-spread");
        }

        return this; //chainable
    }

    showSpread(spread_id){
        if(this.spreads.has(spread_id)) {
            this.spreads.get(spread_id).show();
        }

        return this; //chainable
    }

    nextScene(){
        if( this.currentSpread ){
            this.currentSpread.navigateByInput("NEXT")
        }
    }

    previousScene(){
        if( this.currentSpread ){
            this.currentSpread.navigateByInput("PREV")
        }
    }

    multiActionLink(actions) {
        if( this.currentSpread ){
            this.currentSpread.multiActionLink(actions)
        }
    }

    goToScene(spread_id, sceneId) {
        const spread = this.spreads.get(spread_id) ?? this.currentSpread
        spread?.sceneLink(sceneId)
    }

    getSpreadInfo (spreadId) {
        const spread = this.spreads.get(spreadId)
        if (spread) {
            return {
                activeScene: spread.currentScene.uuid,
                scenes: spread.scenes.filter(scene => !scene.sticky && !scene.isPopup).map(scene => scene.uuid),
                scrollingScenes: spread.active_layout === LAYOUT_DESKTOP ? spread.scrolling_scenes : spread.scrollingMobileScenes,
            }
        }
    }

    messageReceived(event) {
        //don't do anything with messages from yourube or vimeo
        if ((/^https?:\/\/(www\.youtube|player\.vimeo)\.com/).test(event.origin) || event.data?.source === 'react-devtools-content-script') {
            return false;
        }
        let message = event.data;

        switch (message.message) {
            case "SHOW":
                this.currentSpreadId = message.spread_id;
                message.spread_id = message.spread_id || this.spreads.keys().next().value;
                this.showSpread(message.spread_id);
                break;
            case "START":
                message.spread_id = message.spread_id || this.spreads.keys().next().value;
                this.startSpread(message.spread_id);
                break;
            case "STOP":
                message.spread_id = message.spread_id || this.spreads.keys().next().value;
                this.stopSpread(message.spread_id);
                break;
            case "IFRAME_EMBED_MESSAGE":
                this.embedMessageReceived(message);
                break;
            case "TRIGGER_KEYDOWN":
                break;
            case "VIEWPORT_CHANGE":
                break;
            case "TOP_URL":
                break;
            case "TOGGLE_SAFEZONE":
                this.currentSpread.getSpreadElement(false).classList.toggle('safezone-visible')
                break;
            case "FUNCTION_EXPAND":
                this.currentSpread.sceneLink("NEXT")
                break;
            case "FUNCTION_EXPAND_CLOSE":
                this.currentSpread.sceneLink("FIRST")
                break;
            default :
                if (window.frontend === true) {
                    this.messageReceivedFrontend(event);
                }
                break;
        }
    }

    embedMessageReceived(message){
        if( message.identifier ){
            $(`[data-identifier="${message.identifier}"].embed iframe`).trigger("IFRAME_EMBED_MESSAGE", [message]);
        }
    }

    issuesJsonFetched(data){
        $(document).trigger("issues_json.maglr", {json:data});
    }

    bindKeyboardNavigation() {
        $(document)
            .off('keydown.maglr')
            .on('keydown.maglr', (e) => {
                //only do something when not in input or the target is the document itself.
                if (e.target === document || (e.target.tagName && ["input", "textarea", "button", "select", "option"].includes(e.target.tagName.toLocaleLowerCase()) === false) ){
                    switch (e.which) {
                        case 37: // arrow left
                            //Message.sendMessage("PREVIOUS_PAGE", this.currentSpreadId );
                            Message.sendMessage("PREVIOUS_PAGE", this.currentSpreadId || "notset" );
                         //   e.preventDefault(); // prevent the default action (scroll / move caret)
                            break;
                        case 39: // arrow right
                        case 32: // spacebar
                            //Message.sendMessage("NEXT_PAGE", this.currentSpreadId );
                            Message.sendMessage("NEXT_PAGE", this.currentSpreadId || "notset" );
                         //   e.preventDefault(); // prevent the default action (scroll / move caret)
                            break;
                        // case 38: // arrow up
                        //     if(this.currentSpread && this.currentSpread.navigateByInput("PREV") ){
                        //         e.preventDefault(); // prevent the default action (scroll / move caret)
                        //     }
                        //     break;
                        // case 13: // enter key
                        // case 40: // arrow down
                        //     if(this.currentSpread && this.currentSpread.navigateByInput("NEXT") ){
                        //         e.preventDefault(); // prevent the default action (scroll / move caret)
                        //     }
                        //     break;
                    }
                }
            })
        ;

        return this; //chainable
    }

//////////////////////////////////////////////////////// SINGLE SPREAD SETUP ////////////////////////////////////////////////////////


    AjaxPromise(options) {
        return new Promise(function (resolve, reject) {
            $.get(options).done(resolve).fail(reject);
        });
    }

    fetchSpreadSettings(spread_id){

        if( window._spreads && window._spreads[spread_id] ){
            console.log('jup');
            this.createSpread(spread_id, window._spreads[spread_id]);
        }else{
            this.AjaxPromise(
                {url:`${spread_id}.js`}
            ).then(
                (data) => {
                    this.createSpread(spread_id, window._spreads[spread_id]);
                },
                (jqXHR, textStatus, errorThrown) => {
                    alert( "failed to load '" + spread_id + "' settings");
                }
            ).catch((error) => {
                    alert( "error fetchSpreadSettings" );
            });

        }

    }

    setSingleSpread(){
        this.setConnectorSingleSpread();
        this.bindMessageListener();

        //get first spread_id in html
        let first_spread_id = $('[data-spread_id]').first().data('spread_id');
        this.currentSpreadId = first_spread_id;
        this.fetchSpreadSettings(first_spread_id);

        return this; //chainable
    }

    bindMessageListener(){
        if (!this.boundMessageListener) {
            this.boundMessageListener = (event) => this.messageReceived(event)
            window.addEventListener("message", this.boundMessageListener, false);
        }
        return this; // chainable
    }

    setConnectorSingleSpread(mode = ''){
        this._singleSpreadMode = mode; // embed | inject | singlepage | component | ''
        window.frontend = true

        if (mode === 'singlepage') {
            //set a timeout that pushes an event after x seconds when no other event has been pushed yet
            this.bounceRateTimer = setTimeout(() => {
                try{
                    UserEvents.sendEventUpdate('User-still-there?', `No-interaction`, '15-seconds', this.currentSpread.getSettings() );
                }catch(e){}
            },15000);
        } else if (mode === 'inject') {
            this.injectObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    console.log("visible?", entry.intersectionRatio > 0)
                    if (entry.intersectionRatio > 0) {
                        const spreadId = parseInt(entry.target.dataset.spread_id)
                        this.injectObserver.unobserve(entry.target)
                        this.spreads.get(spreadId).safemargin.onWindowResizeEvent(null, {force:true});
                        this.startSpread(spreadId)
                    }
                });
            });
        // } else if (mode === 'component') {
        //     this.shadowHost = host
        }

        return this; //chainable
    }

    messageReceivedFrontend(event) {
        if (event.data !== undefined && event.data.message !== undefined) {
            let message = event.data;
            switch (message.message) {
                case "PAGE_LOADED":
                    this.showSpread(message.origin_spread_id);
                    break;
                case "PAGE_READY":
                    if (this.injectObserver) {
                        this.injectObserver.observe(this.spreads.get(message.origin_spread_id).getSpreadElement(false));
                    } else {
                        this.startSpread(message.origin_spread_id);
                    }
                    break;

                /* SINGLEPAGE */
                case "external_link":
                    if(event.origin !== window.location.origin){
                        console.warn("invalid origin");
                        return false;
                    }
                    let link = document.createElement('a');
                    if(message.link.indexOf('/') === -1 && message.link.indexOf('mailto:') === -1){
                        message.link = '//'+message.link;
                    }
                    if(message.link.indexOf('mailto:') === 0 ){
                        return window.location.href = message.link;
                    }
                    link.href = message.link;

                    let browser = checkBrowser(),
                        target = message.target || (message.not_blank ? '_self' : '_blank')
                    ;
                    if( browser === CONSTANTS.VENDORS.SAFARI) {
                        link.setAttribute('target', target);
                        link.click();
                    }else if( browser === CONSTANTS.VENDORS.EDGE ){
                        window.open(message.link, target);//new policy won't open <a> element
                    }else{
                        window.open(link, target);
                    }
                    break;
                case "file_link":
                    if(event.origin !== window.location.origin){
                        console.warn("invalid origin");
                        return false;
                    }
                    window.open(message.link, '_blank');
                    break;
                case "internal_link":
                    if(event.origin !== window.location.origin){
                        console.warn("invalid origin");
                        return false;
                    }
                    if(this._singleSpreadMode === 'singlepage' && window.maglrShorttags){
                        let issue_id = parseInt(message.issue_id),
                            spread_id = parseInt(message.spread_id)
                        ;
                        for (let shorttag in window.maglrShorttags) {
                            if(window.maglrShorttags[shorttag].js_spread_spread_id === spread_id && window.maglrShorttags[shorttag].js_issue_issue_id === issue_id){
                                const url = new URL(window.location);
                                url.pathname = window.maglrShorttags[shorttag].url;
                                if(message.scene_id && message.scene_id !== "false"){
                                    url.searchParams.set("scene", message.scene_id);
                                }

                                window.location = url.href;
                                break;
                            }
                        }

                    }
                    break;
                case "USER_EVENT":
                    let data
                    if (message.dataGA4 || message.dataGA3) {
                        pushAnalyticsEvent(message);
                    } else {
                        data = {
                            'hitType': 'event',//
                            'page': window.location.pathname,
                            'eventCategory': message.type,//example VIDEO, URL_CHANGED
                            'eventAction': message.action,//example START, STOP, OPENED
                            'eventLabel': message.label,
                            'eventValue': message.value,//example https://youtu.be/w?-
                        };
                        pushAnalyticsEvent(data);
                    }
                    break;

                /* EMBED */
                case "HANDSHAKE.EMBED":
                    // This message is received when the current page is embedded. We now know we have some control over
                    // the iframe and its container.
                    if(this.currentSpread){
                        this.embedHandshake && clearTimeout(this.embedHandshake.timeout)
                        this.embedHandshake.connected = true
                        this.currentSpread.setEmbedded(message.data);

                        //set the viewport size
                        this.currentSpread.setViewportSize(message.data.viewport);

                        try {
                            if (window.makeLogger && message.data.location && message.data.type === CONSTANTS.EMBEDTYPES.FULLHEIGHT && this.currentSpread.scenes.filter(scene => scene.pagetype === PAGETYPES.LONGPAGE).length > 0) {
                                const params = new URLSearchParams({
                                    embed_hash: window.embedHash,
                                    location: message.data.location,
                                    client_id: window.client_id,
                                    spread_id: window.spread_id,
                                    issue_id: window.issue_id
                                })
                                const url= new URL(`https://hook.eu1.make.com/lq5mu3ec5udvu9rb8gx6hmqo99ix93dy?${params}`) ;
                                const request = new XMLHttpRequest();
                                request.open("GET", url);
                                request.send();
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    }

                    break;
                case "HANDSHAKE_MISSED.EMBED":
                    if (!this.embedHandshake.connected) {
                        this.embedHandshake.counter = 0;
                        this.embedHandshake.retry = true;
                        this.initiateEmbedHandshake()

                    }
                    break;
                case "SET_VIEWPORT.EMBED":
                    //set the viewport size
                    if(this.currentSpread && this.lastViewport !== JSON.stringify(message.data.viewport) ){
                        this.lastViewport = JSON.stringify(message.data.viewport)
                        this.currentSpread.setViewportSize(message.data.viewport);
                    }
                    break;
                case "UPDATE_SCROLL_POSITION.EMBED":
                    if(this.currentSpread){
                        if (this.BUILDINFO.major >= 12) {
                            window.scrollTo(0, Math.max(message.data.scroll.top, 0))
                        } else {
                            this.currentSpread.setScrollPosition(message.data.scroll);
                        }
                    }
                    break;
                case "START.EMBED":
                    if(this.currentSpread){
                        this.currentSpread.start();
                    }
                    break;
                case "STOP.EMBED":
                    if(this.currentSpread){
                        this.currentSpread.stop();
                    }
                    break;
                case "COOKIE_CONSENT":
                    this.initCookieBar(true);
                    break;

                case "GET_TOP_URL":
                    let location = window.location
                    if (this._singleSpreadMode === 'inject' && !message.origin_spread_id) {
                        const originSpread = this.findEventSource(event.source);
                        const embedHash = originSpread?.options?.injected?.embedHash
                        if (embedHash) {
                            location = new URL(document.querySelector(`script[src*=${embedHash}]`).getAttribute('src'))
                        }
                    }
                    const {hostname, protocol, pathname, href} = location
                    event.source.postMessage({
                        'message': 'TOP_URL',
                        'data': {hostname, protocol, pathname, href, fullURL : `${protocol}//${hostname}${pathname}`}
                    }, '*');
                    break;
                case "FORM_SUBMIT_SUCCESS":

                    let spread = this.currentSpread
                    if (this._singleSpreadMode === 'inject') {
                        const originSpread = this.findEventSource(event.source);
                        if (originSpread) {
                            spread = originSpread
                        }
                    }

                    UserEvents.sendEventUpdate('Form', `Submit`, message.formName, spread.getSettings(), message.uuid && spread.runSelector('#'+message.uuid)[0] );
                    if(window !== window.parent){
                        window.parent.postMessage(message, '*');
                    }
                    if (message.redirectURL) {
                        const url = new URL(message.redirectURL, window.location.origin);
                        if (url.protocol !== "https:") {
                            console.error("Blocked non-HTTP(S) URL");
                            return;
                        }
                        window.location.href = url.href;
                    }
                    break;
            }
        }
    }

    getBuildInfo(){
        return this.BUILDINFO;
    }

    setGlobalData(data){
        this.globalData = data;
    }

    bindSocketListener(uri){
    }

    setInterfaceSettings(settings){
        this.interfaceSettings = settings;
        if(this.spreads){
            this.spreads.forEach((spread) => {
                spread.setInterfaceSettings(this.interfaceSettings);
            })
        }
        return this;
    }

    setCookieConsented(consented){
        if(consented && this.spreads){
            this.spreads.forEach((spread) => {
                spread.setTriggerCookieConsent(false);
            })
        }
    }

    initCookieBar(force = false){
        let showAfterInit = false;
        if(!this.consentContainer){
            let consentCookie = false;
            if(document.cookie.indexOf('MaglrCookieConsent') > -1){
                let crumb = document.cookie.split(";").filter((crumb) => crumb.indexOf('MaglrCookieConsent') > -1);
                if(crumb.length > 0){
                    consentCookie = crumb[0]
                }
            }else{
                showAfterInit = true; // cookie not yet defined
            }
            window.MaglrCookieConsented = (consentCookie && consentCookie.trim() === "MaglrCookieConsent=true");

            this.consentContainer = document.getElementById("maglrConsentContainer");

            this.consentContainer && this.consentContainer.querySelector('.buttonContainer').addEventListener('click', (event) => {
                if(!event.target || !event.target.dataset || !event.target.dataset.maglrconsent){
                    return;
                }

                this.consentContainer.style.display = 'none';

                let consented = event.target.dataset.maglrconsent === 'accept';

                //write cookie to save the choice
                let d = new Date();
                d.setTime(d.getTime() + (365*24*60*60*1000));
                document.cookie = `MaglrCookieConsent=${consented ? 'true' : 'false'};expires=${d.toUTCString()}`;
                window.MaglrCookieConsented = consented;
                this.setCookieConsented(consented);
                this._consentChanged();
            })

            this._consentChanged();
        }

        if(this.consentContainer){
            if(force || window.MaglrCookieConsented === undefined || showAfterInit){
                this.consentContainer.style.display = 'block';
            }else{
                this.consentContainer.style.display = 'none';
            }
        }
    }

    _consentChanged(){
        if(window.MaglrCookieConsented){
            // if (this._stashedGATracker) {
            //     window.ga = this._stashedGATracker;
            //     delete this._stashedGATracker;
            // }
            if (this._stashedGTAGTracker) {
                window.gtag = this._stashedGTAGTracker;
                delete this._stashedGTAGTracker;
            }
            window.maglr_pirsch && (window.maglr_pirsch.disabled = false)

            if(window.maglrSettings?.cookieConsent?.anonymous === 0){
                try{
                    // if (window.ga) {
                    //     window.ga('set', 'anonymizeIp', false);
                    //     window.ga('set', 'allowAdFeatures', true);
                    // }
                    if (window.gtag) {
                        window.gtag('set', {
                            'anonymizeIp': false,
                            'allowAdFeatures': true
                        });
                    }
                }catch(e){
                    console.error('Error during ga.set "anonymizeIp"');
                }
            }

        }else{
            if(window.gtag || window.maglr_pirsch){
                switch(window.maglrSettings?.cookieConsent?.mode){
                    case 1:
                        // don't send analytics if cookies disabled
                        // this._stashedGATracker = window.ga;
                        this._stashedGTAGTracker = window.gtag;
                        // window.ga = undefined;
                        window.gtag = undefined;
                        window.maglr_pirsch && (window.maglr_pirsch.disabled = true)
                        console.warn("Cookie consent active, so disabled the GA tracker")
                        break;
                    case 2:
                        try{
                            // if (window.ga) {
                            //     window.ga('set', 'anonymizeIp', true);
                            //     window.ga('set', 'allowAdFeatures', false);
                            // }
                            if (window.gtag) {
                                window.gtag('set', {
                                    'anonymizeIp': true,
                                    'allowAdFeatures': false
                                });
                            }
                        }catch(e){
                            console.error('Error during ga.set "anonymizeIp"');
                        }
                        break;
                }
            }
        }
    }

    initiateEmbedHandshake() {
        Message.sendEmbedMessage("HELLO", {
            scrolling_scenes: this.currentSpread.scrolling_scenes,
            height: this.currentSpread.getScrollHeight(true),
            version: BUILD.major,
        });

        if(this.embedHandshake.counter < 3){
            this.embedHandshake.counter++
            this.embedHandshake.timeout = setTimeout(() => {
                this.initiateEmbedHandshake()
            }, 500 * this.embedHandshake.counter)
        }
    }

    reportScrollDepth() {
        this.currentSpread.reportScrollDepth()
    }

    bindPreviewMessageListener() {
        window.addEventListener("message", ({data = {}}) => {
            switch (data?.message) {
                case "HIGHLIGHT_ELEMENT":
                    this.currentSpread.goToAndHighlightElement(data)
                break;
                case "HIGHLIGHT_REMOVE":
                    this.currentSpread.removeHighlight()
                    break;
            }
        }, false);
    }

    findEventSource (eventSource) {
        let result = null
        this.spreads.forEach(spread => {
            spread.getSpreadElement(false).querySelectorAll('iframe').forEach(iframe => {
                if (iframe.contentWindow === eventSource) {
                    result = spread;
                }
            });
        })
        return result
    }
}

if (typeof window.getMaglrController !== 'function') {
    window.maglrControllers = window.maglrControllers ?? {}
    window.getMaglrController = (major) => {
        return window.maglrControllers[major]
    }
}

if (window.maglrController?.BUILDINFO?.major !== BUILD.major) {
    window.maglrController = window.maglrControllers[BUILD.major] = new Controller()
}else {
    console.log(`Controller with same version already loaded (V${BUILD.major})`)
}

